import { PageIntro } from '../components/PageIntro';
import { Seo } from '../components/Seo';

export function AboutPage() {
  return (
    <>
      <Seo title="About" description="Learn how we help low-income families live in safer, healthier homes." />
      <PageIntro eyebrow="About us" title="Keeping a home in good repair should not depend on a family’s income.">
        <p>We help low-income families complete essential repairs that protect their health, safety, and housing stability.</p>
      </PageIntro>
      <section className="section">
        <div className="container content-grid">
          <div>
            <p className="eyebrow">Our story</p>
            <h2>Home repairs should not be out of reach.</h2>
          </div>
          <div className="prose">
            <p>Unexpected repair costs can force families to choose between fixing a serious hazard and meeting other basic needs. We exist to help close that gap.</p>
            <p>Our work centers on practical repairs that keep families safe, preserve affordable homes, and support long-term stability. We listen first, respect every household, and work with trusted partners to make each project count.</p>
          </div>
        </div>
      </section>
      <section className="section section-tinted">
        <div className="container">
          <p className="eyebrow">Our values</p>
          <h2>Principles behind the work.</h2>
          <div className="card-grid value-grid">
            {[
              ['Dignity', 'We treat every family with care, respect, and a voice in decisions about their home.'],
              ['Safety', 'We prioritize repairs that address urgent hazards and support healthy daily living.'],
              ['Stewardship', 'We use resources thoughtfully and build partnerships that create lasting value.'],
            ].map(([value, description]) => (
              <article className="feature-card" key={value}>
                <h3>{value}</h3>
                <p>{description}</p>
              </article>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
